import { GetURLParameter } from './helpers'

function initCircleProgress () {
  window.progressPercents = 0
  $(document).ready(function() {
    if (!window.prepared_for_v2) {
      $('<link/>', {
        rel: 'stylesheet',
        type: 'text/css',
        href: `https://cdn${window.location.hostname.indexOf('staging') > -1 ? '.staging' : ''}.crezu.net/wp_styles/dist/page-reg-v2.css`
      }).appendTo('head');
      $('.progress_bar_holder').remove()
      $('.formcontent.ui-form__wrapper.form-step.active').replaceWith(`<div class="new-form__wrap">
        <!-- CYRCLE -->
        <div class="main-content__cyrcle">
          <div class="sidebar__inner">
            <div class="main-content__cyrcle-progress">
              <span>1%</span>
            </div>
            <p></p>
          </div>
        </div>
        <!-- FORM -->
        <div class="formcontent ui-form__wrapper form-step active">
        </div>
      </div>`)
      $('body').append(`<!-- Fixed progress -->
        <div class="fixed-progress">
          <div class="fixed-pregress__wrap">
            <div class="fixed-progress__cyrcle">
              <span>1%</span>
            </div>
          </div>
          <p><b></b></p>
        </div>
        <!-- Fixed progress ends -->
      `)
    }

    if (GetURLParameter('lead_id') != null) {
      $('.fixed-progress').addClass('hidden');
      $('.main-content__cyrcle').addClass('hidden');
      return
    }

    // cyrcle block
    function startScroll(){
      let cyrcle = $('.main-content__cyrcle');
      let formContent = $(".formcontent");
      cyrcle.css('width', cyrcle.outerWidth());
      let windowCont = $(window);
      windowCont.on('resize',function () {
        windowCont.trigger('scroll')
      })
      windowCont.scroll(function(){
        let h = window.circleTreshhold || 190
        if ((windowCont.scrollTop() + 30) > h){
          cyrcle.addClass('fixed');
          formContent.addClass('toright');
        } else {
          cyrcle.removeClass('fixed');
          formContent.removeClass('toright');
        }
      });
    };
    startScroll();
    function stopScroll(){
      let cyrcle = $('.main-content__cyrcle');
      let formContent = $(".formcontent");
      let formWrap = $(".new-form__wrap");
      let windowCont = $(window);
      windowCont.scroll(function(){
        let bottomCyrcle = cyrcle.offset().top + cyrcle.height();
        let stop = $(".devider").length ? ($(".devider").offset().top - 41) : 9900;
        if (stop < bottomCyrcle && cyrcle.height() < formContent.height()){
          cyrcle.removeClass('fixed');
          formContent.removeClass('toright');
          formWrap.addClass('tobottom');
        }
        else {
          formWrap.removeClass('tobottom');
        }
      });
    };
    stopScroll();
  });
}

export { initCircleProgress }
